import { FC } from "react"
import { SchedulesAddSuccess } from "../../../module/schedules/containers/addSuccess"

export const SchedulesAddSuccessPage: FC = () => <SchedulesAddSuccess />
